import React from 'react';
import AdminDataTable from './AdminDataTable';

/**
 * Configuration pour l'administration des traductions fixes
 */
const fixedTranslationsConfig = {
  entityName: 'fixed_translations',
  apiEndpoint: '/api/config/tool/fixed-translations',
  exportFileName: 'fixed_translations',
  
  translations: {
    title: 'FIXED_TRANSLATIONS_TITLE'
  },
  
  columns: [
    { key: 'id', label: 'ID', labelKey: 'TABLE_ID' },
    { 
      key: 'language_from', 
      label: 'Langue source', 
      labelKey: 'TABLE_LANGUAGE_FROM',
      type: 'dynamic-select',
      dynamicSource: 'language_from'
    },
    { 
      key: 'language_to', 
      label: 'Langue cible', 
      labelKey: 'TABLE_LANGUAGE_TO',
      type: 'dynamic-select',
      dynamicSource: 'language_to'
    },
    { key: 'original_text', label: 'Texte original', labelKey: 'TABLE_ORIGINAL_TEXT' },
    { key: 'translated_text', label: 'Texte traduit', labelKey: 'TABLE_TRANSLATED_TEXT' },
    { 
      key: 'is_regex', 
      label: 'Regex', 
      labelKey: 'TABLE_IS_REGEX',
      type: 'booleanTag'
    },
    { key: 'priority', label: 'Priorité', labelKey: 'TABLE_PRIORITY' },
    { 
      key: 'is_active', 
      label: 'Actif', 
      labelKey: 'TABLE_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  formFields: [
    {
      name: 'language_from',
      label: 'Langue source',
      labelKey: 'FORM_LANGUAGE_FROM',
      type: 'dynamic-select',
      required: true,
      dynamicSource: 'language_from'
    },
    {
      name: 'language_to',
      label: 'Langue cible',
      labelKey: 'FORM_LANGUAGE_TO',
      type: 'dynamic-select',
      required: true,
      dynamicSource: 'language_to'
    },
    {
      name: 'original_text',
      label: 'Texte original',
      labelKey: 'FORM_ORIGINAL_TEXT',
      type: 'textarea',
      required: true,
      placeholder: 'Texte à traduire'
    },
    {
      name: 'translated_text',
      label: 'Texte traduit',
      labelKey: 'FORM_TRANSLATED_TEXT',
      type: 'textarea',
      required: true,
      placeholder: 'Traduction fixe'
    },
    {
      name: 'is_regex',
      label: 'Expression régulière',
      labelKey: 'FORM_IS_REGEX',
      type: 'booleanTag'
    },
    {
      name: 'priority',
      label: 'Priorité',
      labelKey: 'FORM_PRIORITY',
      type: 'number',
      required: false,
      placeholder: 'Priorité (1 = haute, défaut: 1)'
    },
    {
      name: 'is_active',
      label: 'Actif',
      labelKey: 'FORM_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  filters: [
    {
      name: 'language_from',
      label: 'Langue source',
      labelKey: 'FILTER_LANGUAGE_FROM',
      type: 'dynamic-select',
      dynamicSource: 'language_from'
    },
    {
      name: 'language_to',
      label: 'Langue cible',
      labelKey: 'FILTER_LANGUAGE_TO',
      type: 'dynamic-select',
      dynamicSource: 'language_to'
    },
    {
      name: 'original_text',
      label: 'Texte original',
      labelKey: 'FILTER_ORIGINAL_TEXT',
      type: 'text',
      placeholder: 'Filtrer par texte original...'
    },
    {
      name: 'translated_text',
      label: 'Texte traduit',
      labelKey: 'FILTER_TRANSLATED_TEXT',
      type: 'text',
      placeholder: 'Filtrer par texte traduit...'
    },
    {
      name: 'is_regex',
      label: 'Regex',
      labelKey: 'FILTER_IS_REGEX',
      type: 'booleanTag'
    },
    {
      name: 'is_active',
      label: 'Statut',
      labelKey: 'FILTER_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  defaultFormData: {
    language_from: '',
    language_to: '',
    original_text: '',
    translated_text: '',
    is_regex: false,
    priority: 1,
    is_active: true
  }
};

/**
 * Composant d'administration des traductions fixes
 */
export default function AdminFixedTranslationsTab() {
  return (
    <AdminDataTable {...fixedTranslationsConfig} />
  );
}
